import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("aca_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Les lectures (GET) ne doivent jamais rester bloquées indéfiniment — ex. serveur
  // en cours de redémarrage pendant une mise en ligne : au-delà de 20 s, la page
  // affiche le message d'erreur français + « Réessayer » au lieu d'un chargement infini.
  // (Les écritures POST/PUT — générations IA, vidéos — gardent leur propre délai.)
  if (!config.method || config.method.toLowerCase() === "get") config.timeout = config.timeout || 20000;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // Session expirée (jeton de 7 jours) : on renvoie vers la connexion au lieu de
    // laisser des pages vides ou des messages « serveur indisponible » trompeurs.
    if (err?.response?.status === 401 && localStorage.getItem("aca_token") && !window.location.pathname.startsWith("/connexion")) {
      localStorage.removeItem("aca_token");
      window.location.href = "/connexion";
    }
    return Promise.reject(err);
  }
);

export function apiErr(e, fallback = "Une erreur est survenue.") {
  const status = e?.response?.status;
  const d = e?.response?.data?.detail;
  // Erreurs d'infrastructure (Cloudflare 520-527, redémarrage pendant une mise en
  // ligne) ou réponse non-JSON : ne JAMAIS afficher le texte technique anglais brut.
  if (status >= 520 || (typeof d === "string" && /cloudflare|origin web server/i.test(d))) {
    return "Le serveur est momentanément indisponible (mise en ligne en cours) — réessayez dans une minute.";
  }
  if (status === 502 || status === 503 || status === 504) {
    return "Le serveur est momentanément indisponible — réessayez dans quelques instants.";
  }
  if (!e?.response) {
    return "Connexion au serveur impossible — vérifiez votre connexion ou réessayez dans une minute.";
  }
  if (d == null) return e?.message && !/network error/i.test(e.message) ? e.message : fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

// Suppressions admin (icônes poubelle) : mot de passe obligatoire, vérifié côté serveur.
// Retourne la réponse, ou null si l'utilisateur a annulé la saisie.
export async function adminDelete(url) {
  const pwd = window.prompt("Action protégée — saisissez le mot de passe de suppression pour confirmer :");
  if (pwd === null) return null; // annulé
  return api.delete(url, { headers: { "x-admin-delete-password": pwd } });
}

// Actions sensibles (ex. intégration au comité de décision) : code de sécurité obligatoire.
// Retourne la réponse, ou null si l'utilisateur a annulé la saisie.
export async function adminPutProtected(url, body) {
  const pwd = window.prompt("Action protégée — saisissez le code de sécurité pour confirmer :");
  if (pwd === null) return null; // annulé
  return api.put(url, body, { headers: { "x-admin-action-code": pwd } });
}
